import { createApiRef } from '@backstage/core-plugin-api';

const searchApiRef = createApiRef({
  id: "plugin.search.queryservice"
});
class MockSearchApi {
  constructor(mockedResults) {
    this.mockedResults = mockedResults;
  }
  query() {
    return Promise.resolve(this.mockedResults || { results: [] });
  }
}

export { MockSearchApi, searchApiRef };
//# sourceMappingURL=api.esm.js.map
